import * as React from "react";

export const File = (props: { color: string; size?: number }) => {
    const size = props.size ?? 24;
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.8611 7.22222L11.3889 3.75002L6.35416 3.75C6.03185 3.75 5.72274 3.8817 5.49483 4.11612C5.26692 4.35054 5.13889 4.66848 5.13889 5V15C5.13889 15.3315 5.26692 15.6495 5.49483 15.8839C5.72274 16.1183 6.03185 16.25 6.35416 16.25H13.6458C13.9681 16.25 14.2773 16.1183 14.5052 15.8839C14.7331 15.6495 14.8611 15.3315 14.8611 15V7.22222ZM11.3889 3.75002V7.22222H14.8611"
                stroke={props.color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
